var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttention(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 16.5,
    fill: "#71903E",
    fillOpacity: 0.1,
    stroke: "#71903E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7833 9L18.3892 19.4272H15.532L15.1379 9H18.7833ZM17.0099 25C16.4187 25 15.9327 24.8113 15.5517 24.434C15.1839 24.0422 15 23.5633 15 22.9973C15 22.4168 15.1839 21.9306 15.5517 21.5388C15.9327 21.1469 16.4187 20.951 17.0099 20.951C17.5878 20.951 18.0608 21.1469 18.4286 21.5388C18.8095 21.9306 19 22.4168 19 22.9973C19 23.5633 18.8095 24.0422 18.4286 24.434C18.0608 24.8113 17.5878 25 17.0099 25Z",
    fill: "#71903E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttention);
export default __webpack_public_path__ + "static/media/attention.9cfcef61e6080901e10593ff345a0e1e.svg";
export { ForwardRef as ReactComponent };